const firebaseConfig = {
  apiKey: "AIzaSyAkuIJqsWXZH8epNRPcTDuZGhlU2kNPzAU",
  authDomain: "architech-28d6b.firebaseapp.com",
  projectId: "architech-28d6b",
  storageBucket: "architech-28d6b.appspot.com",
  messagingSenderId: "1035425116595",
  appId: "1:1035425116595:web:d38bef90d7749924161bc6",
  measurementId: "G-6JBJL8GK05"
};

export default firebaseConfig;
